// extracted by mini-css-extract-plugin
export default {"partner_div":"partners_partner_div__Psrk5","partner_div_img":"partners_partner_div_img__nGrNd","alice_carousel":"partners_alice_carousel__4edIP"};